<template>
  <div class="stat-card revenue-card">
    <div class="stat-header revenue-header">
      <div class="header-left">
        <span class="stat-title">EST. DAILY REVENUE IMPACT</span>
        <i class="info circle icon" title="Estimated daily revenue impact from products where you don't hold the Buy Box"></i>
      </div>
    </div>
    <div class="stat-value revenue">
      <span class="revenue-symbol">-</span>
      <span class="revenue-amount">{{ formatCompactAmount(data.amount) }}</span>
      <span class="revenue-period">/day</span>
    </div>
    <div class="stat-subtitle" v-if="data.subtitle">
      {{ data.subtitle }}
    </div>
    <div class="stat-description" v-else>
      From <strong>{{ data.affectedProducts }} products</strong> where you don't hold the Buy Box.
    </div>
    <div class="revenue-breakdown">
      <div class="breakdown-item weekly-impact">
        <div class="breakdown-label">
          THIS WEEK (EST.)
          <i class="info circle icon small" title="Weekly Revenue Impact: Cumulative estimated revenue impact over the past 7 days"></i>
        </div>
        <div class="breakdown-value negative"><strong>{{ formatCompactValue(data.weeklyImpact) }}</strong></div>
      </div>
      <div class="breakdown-item actionable-item">
        <div class="breakdown-label">
          ACTIONABLE
          <i class="info circle icon small" title="Actionable Products: Products where you can potentially win back the Buy Box through price adjustment"></i>
        </div>
        <div class="breakdown-value actionable"><strong>{{ data.actionableProducts }} products</strong></div>
      </div>
    </div>
  </div>
</template>

<script>
import './styles/RevenueImpactCard.css'

export default {
  name: 'RevenueImpactCard',
  props: {
    data: {
      type: Object,
      required: true
      // Expected structure:
      // {
      //   amount: String,
      //   affectedProducts: Number,
      //   weeklyImpact: String,
      //   actionableProducts: Number,
      //   avgRecovery: String
      //   reportingCurrencySymbol: String  // from API reporting_currency_symbol
      // }
    }
  },
  computed: {
    reportingSymbol: function () {
      return (this.data && this.data.reportingCurrencySymbol) || '$'
    }
  },
  methods: {
    formatCompactAmount: function (val) {
      var sym = this.reportingSymbol
      var num = parseFloat(String(val).replace(/[^0-9.-]/g, ''))
      if (isNaN(num)) return sym + val
      var abs = Math.abs(num)
      var sign = num < 0 ? '-' + sym : sym
      var formatted
      if (abs >= 1000000) {
        formatted = (abs / 1000000).toFixed(1).replace(/\.0$/, '') + 'M'
      } else if (abs >= 1000) {
        var kVal = abs / 1000
        formatted = (kVal >= 100 ? Math.round(kVal) : kVal.toFixed(1).replace(/\.0$/, '')) + 'K'
      } else {
        formatted = Number.isInteger(num) ? String(num) : num.toFixed(2)
      }
      return sign + formatted
    },
    formatCompactValue: function (val) {
      if (val == null) return ''
      var sym = this.reportingSymbol
      var str = String(val).trim()
      var match = str.match(/(-?)\s*[^0-9-]*\s*([0-9,]+\.?[0-9]*)\s*([kKmM]?)/i)
      if (!match) return str.replace(/\$/g, sym)
      var sign = (str.indexOf('-') >= 0) ? '-' + sym : sym
      var num = parseFloat(match[2].replace(/,/g, ''))
      var suffix = (match[3] || '').toUpperCase()
      if (isNaN(num)) return val
      if (suffix === 'K') num = num * 1000
      if (suffix === 'M') num = num * 1000000
      var abs = Math.abs(num)
      var formatted
      if (abs >= 1000000) {
        formatted = (abs / 1000000).toFixed(1).replace(/\.0$/, '') + 'M'
      } else if (abs >= 1000) {
        var kVal = abs / 1000
        formatted = (kVal >= 100 ? Math.round(kVal) : kVal.toFixed(1).replace(/\.0$/, '')) + 'K'
      } else {
        formatted = (abs >= 1 ? abs.toFixed(1).replace(/\.0$/, '') : abs.toFixed(2))
      }
      return sign + formatted
    }
  }
}
</script>





// WEBPACK FOOTER //
// RevenueImpactCard.vue?31d376da